var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCirclePlus = function SvgCirclePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "plus-circle",
    viewBox: "0 0 110 110"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 49
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v40M35 55h40"
  })));
};
export default SvgCirclePlus;